import Box, { BoxProps } from '@mui/material/Box';
import { PropsWithChildren } from 'react';

const OptionFormWrapper: React.FC<PropsWithChildren<BoxProps<'form'>>> = ({
  children,
  sx,
  ...props
}) => (
  <Box
    component={'form'}
    noValidate
    autoComplete="off"
    sx={{
      width: '100%',
      gap: 4,
      display: 'flex',
      flexDirection: 'column',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default OptionFormWrapper;
